import { LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui";
export default function Welcome({ onLogin }: { onLogin: () => void }) {
  const { t } = useTranslation("ui");
  return (
    <section className="vl-public-content">
      <span className="vl-eyebrow">Valid Labels</span>
      <h1>{t("welcomeTitle")}</h1>
      <p>{t("welcomeText")}</p>
      <Button onClick={onLogin}>
        <LogIn />
        {t("signIn")}
      </Button>
      <p className="vl-hint">{t("welcomeNote")}</p>
    </section>
  );
}
